import React, { useState, useEffect } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import { Select, FiltersContainer, DatePicker, Txt } from '../../../../components'
import { setPayload } from '../../helpers'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import { filtersStyles as styles } from '../../../../components/FiltersContainer/styles'
import moment from 'moment'

const Filters = ({ initialValues, modalRef, onClose, handleSearch, handleClearFilters }) => {
  const { isDesktop } = usePlatforms()
  const [filters, setFilters] = useState({})

  useEffect(() => {
    setFilters(initialValues)
  }, [initialValues])

  const handleSetFilters = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }))
  }
  const handleOnPress = () => {
    const body = setPayload(filters)
    if (!Object.keys(body).length) return
    handleSearch(filters)
    onClose()
  }

  const parseToDateFormat = (date) => moment(date).format('YYYY-MM-DD')

  return (
    <FiltersContainer
      modalRef={modalRef}
      onClose={onClose}
      handleSearch={handleOnPress}
      handleClearFilters={handleClearFilters}
    >
      <View style={[isDesktop && styles.inputsContainer]}>
        <View style={[styles.input, isDesktop && { marginRight: 15 }]}>
          <View style={isDesktop ? styles.dateLabel : { marginBottom: 5 }}>
            <Txt
              text='Get since'
              identity='body3'
              color='SLATE_GRAY'
            />
          </View>
          <DatePicker
            name='LastModifiedDateFrom'
            placeholder='Last Modified Date From'
            value={filters.LastModifiedDateFrom}
            onChange={(name, value) => handleSetFilters(name, parseToDateFormat(value))}
          />
        </View>
        <View style={[styles.input, isDesktop && { marginRight: 15 }]}>
          <Select
            name='InvoiceStatusID'
            selected={filters.InvoiceStatusID}
            onChange={handleSetFilters}
            placeholder='Status'
            keyProp='value'
            nameProp='label'
            options={[
              {
                value: 1,
                label: 'Pending'
              },
              {
                value: 2,
                label: 'Approved'
              },
              {
                value: 3,
                label: 'Paid'
              },
              {
                value: 5,
                label: 'Held'
              },
              {
                value: 6,
                label: 'Import Error'
              },
              {
                value: 8,
                label: 'Removed'
              },
              {
                value: 10,
                label: 'Pending Reissue'
              },
              {
                value: 11,
                label: 'Missing Bank'
              }
            ]}
          />
        </View>
      </View>
    </FiltersContainer>
  )
}

Filters.propTypes = {
  initialValues: PropTypes.object.isRequired,
  modalRef: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func
}

export default Filters
